import { FormActivity } from "@/models/activity.model";

export class ActivityMapper {
  toDomain(response: any): FormActivity {
    const startDate = response?.startDate;
    const finalDate = response?.finalDate;
    return {
      courseId: response?.course?.id,
      classroomId: response?.classroom?.id,
      title: response?.title,
      startDate: new Date(
        startDate[0],
        startDate[1] - 1,
        startDate[2],
        startDate[3],
        startDate[4]
      ),
      finalDate: new Date(
        finalDate[0],
        finalDate[1] - 1,
        finalDate[2],
        finalDate[3],
        finalDate[4]
      ),
      finalHour: this.extractHour(response?.finalDate),
      description: response?.description,
      learningObjetiveId: "",
      scoreRange: response?.scoreRange,
      chapterId: response?.chapterId,
      files: [],
      materials: response?.materials,
      materialsToRemove: [],
    };
  }

  private extractHour(timestamp: number): string {
    const timeZoneOffset = new Date().getTimezoneOffset() / 60;
    const date = new Date(
      timestamp[0],
      timestamp[1] - 1 -timeZoneOffset,
      timestamp[2],
      timestamp[3],
      timestamp[4]
    );
    const time = {
      hours: date.getHours(),
      minutes: date.getMinutes(),
    };

    return this.formatTime(time);
  }

  private formatTime({ hours, minutes }): string {
    return `${this.padZero(hours)}:${this.padZero(minutes)}`;
  }

  private padZero(num: number): string {
    return num.toString().padStart(2, "0");
  }
}
